import { createReducer, on } from '@ngrx/store';
import { UtilityValueRaw } from 'brain-data/model/utility-value-raw.model';
import {
  loadContractRawValues,
  loadContractRawValuesError,
  loadContractRawValuesSuccess,
} from '../actions/contract-raw-values.action';

export default interface ContractRawValuesState {
  byContract: { [contractNumber: string]: UtilityValueRaw[] };
  loadingByContract: { [contractNumber: string]: boolean };
  errorByContract: { [contractNumber: string]: Error };
}

export const initialState: ContractRawValuesState = {
  byContract: {},
  loadingByContract: {},
  errorByContract: {},
};

const trim = (s: string) => s.trim();

export const reducer = createReducer(
  initialState,
  on(loadContractRawValues, (state, { contractNumber }): ContractRawValuesState => ({
    ...state,
    loadingByContract: { ...state.loadingByContract, [trim(contractNumber)]: true },
  })),
  on(loadContractRawValuesSuccess, (state, { contractNumber, values }): ContractRawValuesState => {
    const key = trim(contractNumber);
    const nextLoading = { ...state.loadingByContract };
    delete nextLoading[key];
    return {
      ...state,
      byContract: { ...state.byContract, [key]: values },
      loadingByContract: nextLoading,
    };
  }),
  on(loadContractRawValuesError, (state, { contractNumber, error }): ContractRawValuesState => {
    const key = trim(contractNumber);
    const nextLoading = { ...state.loadingByContract };
    delete nextLoading[key];
    return {
      ...state,
      loadingByContract: nextLoading,
      errorByContract: { ...state.errorByContract, [key]: error },
    };
  }),
);
